import { useT } from "../../contexts/LanguageContext";

function bucket(n) {
  if (n === 0) return 0;
  if (n < 5) return 1;
  if (n < 15) return 2;
  if (n < 30) return 3;
  return 4;
}

const COLORS = ["#F1F5F9", "#BFDBFE", "#60A5FA", "#2563EB", "#002FA7"];

export default function ActivityHeatmap({ data }) {
  const { t, lang } = useT();
  // 12 columns × 7 rows (Mon..Sun). data is 84 days chronological.
  // Reshape: group by week starting Monday of first date; day index = Mon=0..Sun=6
  const cells = data || [];
  const total = cells.reduce((s, c) => s + (c.solved || 0), 0);
  const activeDays = cells.filter((c) => c.solved > 0).length;

  // Build 12 weeks × 7 days grid. Column 0 = oldest.
  const grid = [];
  for (let w = 0; w < 12; w++) grid.push([null, null, null, null, null, null, null]);
  cells.forEach((c) => {
    const dt = new Date(c.date + "T00:00:00Z");
    const dayOfWeek = (dt.getUTCDay() + 6) % 7; // Mon=0..Sun=6
    const firstDate = new Date(cells[0].date + "T00:00:00Z");
    const dayDelta = Math.round((dt - firstDate) / 86400000);
    const weekIdx = Math.floor(dayDelta / 7);
    if (weekIdx >= 0 && weekIdx < 12) grid[weekIdx][dayOfWeek] = c;
  });

  const dayLabels = lang === "tr"
    ? ["Pzt", "Çar", "Cum"]
    : ["Mon", "Wed", "Fri"];

  return (
    <div className="card lg:col-span-8" data-testid="activity-heatmap">
      <div className="flex items-start justify-between">
        <div>
          <div className="overline">{t("analytics.heatmap_overline")}</div>
          <h3 className="font-display text-xl font-semibold mt-1">{t("analytics.heatmap_title")}</h3>
        </div>
        <div className="text-right">
          <div className="overline">{t("analytics.total_solved")}</div>
          <div className="font-display text-2xl font-bold mt-1">{total}</div>
          <div className="text-xs text-slate-500 mt-0.5">{activeDays} {t("analytics.active_days")}</div>
        </div>
      </div>

      <div className="mt-5 flex gap-2 overflow-x-auto">
        <div className="flex flex-col justify-between py-1 pr-1 text-[10px] text-slate-400 font-mono">
          {dayLabels.map((d) => <span key={d}>{d}</span>)}
        </div>
        <div className="flex gap-1">
          {grid.map((week, wi) => (
            <div key={wi} className="flex flex-col gap-1">
              {week.map((cell, di) => {
                const b = cell ? bucket(cell.solved) : 0;
                return (
                  <div
                    key={di}
                    title={cell ? `${cell.date}: ${cell.solved} ${t("common.questions").toLowerCase()}` : ""}
                    className="w-4 h-4 rounded-sm transition-all hover:ring-2 hover:ring-[#002FA7]"
                    style={{ backgroundColor: COLORS[b] }}
                    data-testid={`heatmap-cell-${wi}-${di}`}
                  />
                );
              })}
            </div>
          ))}
        </div>
      </div>

      <div className="mt-4 flex items-center justify-end gap-2 text-xs text-slate-500">
        <span>{t("analytics.less")}</span>
        {COLORS.map((c, i) => (
          <span key={i} className="w-3 h-3 rounded-sm" style={{ backgroundColor: c }} />
        ))}
        <span>{t("analytics.more")}</span>
      </div>
    </div>
  );
}
